import React, {useEffect, useState} from 'react';
import {PcUserName} from './pc/PcUserName'; // 注意这里是默认导入
import {MobileUserName} from './mobile/MobileUserName'; // 注意这里是默认导入

function UserName({isMobile, clicked, clickNext,value, setAllow, isCurPage, ...props}) { // 接收 isMobile props
    const [userName, setUserName] = useState(value);
    useEffect(() => {
        setAllow(!!userName);
    }, [userName]);

    useEffect(() => {
        if (clicked) {
            clickNext(userName)
        }
    }, [clicked]);
    // 确保 clickNext 和 clickPrev props 被传递，如果未提供则使用空函数作为默认值
    const commonProps = {
        ...props,
        clicked,
        userName,
        setUserName,
        isCurPage,
        clickNext: clickNext || (() => {}),
        clickPrev: props.clickPrev || (() => {})
    };

    if (isMobile) { // 根据 isMobile props 条件渲染
        return <MobileUserName {...commonProps} />;
    } else {
        return <PcUserName {...commonProps} />;
    }
}

export default UserName;